import VaultCloseComponent from './vault_close.component';

let vaultCloseModule = angular.module('vaultClose', [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/vault-close');

    $stateProvider
      .state('vaultClose', {
        url: '/vault-close',
        component: 'vaultClose',
        data: {
          requireLogin: true,
          requireACL: 'vault_close.all'          
        },
        parent: 'app',
      });
  })

  .component('vaultClose', VaultCloseComponent)

  .name;

export default vaultCloseModule;


// WEBPACK FOOTER //
// ./client/app/components/vault_close/index.js